module.exports = __webpack_public_path__ + "img/banner.1391aefc.jpg";